var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLedger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1211 3.71411H9.80811V13.5811H19.6821V6.26711C19.6821 5.59001 19.4131 4.94065 18.9344 4.46187C18.4556 3.98309 17.8062 3.71411 17.1291 3.71411H17.1211ZM7.52811 3.71411H6.26811C5.93276 3.71398 5.60067 3.77992 5.29081 3.90816C4.98095 4.0364 4.6994 4.22443 4.46222 4.46151C4.22505 4.6986 4.03691 4.98008 3.90854 5.28989C3.78018 5.5997 3.71411 5.93176 3.71411 6.26711V7.52711H7.52811V3.71511V3.71411ZM3.71411 13.6211H7.52811V9.80811H3.71411V13.6211ZM15.9011 19.6821H17.1611C17.4964 19.6821 17.8284 19.6161 18.1381 19.4878C18.4478 19.3595 18.7293 19.1714 18.9664 18.9344C19.2034 18.6973 19.3915 18.4158 19.5198 18.1061C19.6481 17.7964 19.7141 17.4644 19.7141 17.1291V15.9011H15.9011V19.6821ZM9.80811 19.7141H13.6211V15.9011H9.80811V19.7141ZM3.71411 15.9011V17.1611C3.71411 17.8382 3.98309 18.4876 4.46187 18.9664C4.94065 19.4451 5.59001 19.7141 6.26711 19.7141H7.52711V15.9011H3.71511H3.71411Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLedger);
export default __webpack_public_path__ + "static/media/Ledger.6f5b78c22e27f2b785f3df509b41a48d.svg";
export { ForwardRef as ReactComponent };